import { buildUrl, replaceParameters } from '@/common-utils/functions/restUtils';
import { client } from '@/common-utils/libraries/axios/axios';
import { PLANS } from '../apiUrls';
import plansFields from '../../fields/plansFields';

/**
 * @param {Object} responseData
 * @param {Object[]} responseData.items
 * @param {string} responseData.uuid
 * @param {string} responseData.label
 * @param {string} responseData.ownerOrganization
 * @param {string} responseData.productCode
 * @param {string} responseData.createdAt
 * @param {string} responseData.updatedAt
 * @param {number} responseData.totalResults
 * @param items
 * @returns Mapped data object
 */
function mapResponseData(items) {
    const data = {};
    const mappedItems = items.map(item => ({
        [plansFields.UUID.key]: item[plansFields.UUID.key],
        [plansFields.LABEL.key]: item[plansFields.LABEL.key],
        [plansFields.OWNER_ORGANIZATION.key]: item[plansFields.OWNER_ORGANIZATION.key],
        [plansFields.PRODUCT_CODE.key]: item[plansFields.PRODUCT_CODE.key],
        [plansFields.CREATED_AT.key]: item[plansFields.CREATED_AT.key],
        [plansFields.UPDATED_AT.key]: item[plansFields.UPDATED_AT.key]
    }));

    data.items = mappedItems;
    data.totalResults = items.length;
    return data;
}

const queryGetParentPlans = ({ query, organizationId }, enabled) => {
    return {
        queryKey: [PLANS.COLLECTION_PARENT_PLANS.queryKey, query, organizationId],
        queryFn: async () => {
            const response = await client.get(buildUrl(replaceParameters(PLANS.COLLECTION_PARENT_PLANS.url, { organizationId: organizationId }), query));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};

export default queryGetParentPlans;